import { type AnalyticsClient } from '@databases/analytics';
import type { MessageFormatter } from '@databases/intl/intl-types';
import type { ShowPanelType } from '@databases/panel/PanelContext';

import { type BuildProps, type User } from './types.ts';

export class BaseMentionBuilder {
  protected formatMessage: MessageFormatter;
  protected usersWithAccess: User[];
  protected usersWithoutAccess: User[];
  protected isLocked: boolean;
  protected showPanel: ShowPanelType;
  protected fieldId: string;
  protected analyticsClient: AnalyticsClient;
  protected contentId: string;

  constructor({
    formatMessage,
    usersWithAccess,
    usersWithoutAccess,
    isLocked,
    showPanel,
    fieldId,
    analyticsClient,
    contentId
  }: BuildProps) {
    this.formatMessage = formatMessage;
    this.usersWithAccess = usersWithAccess;
    this.usersWithoutAccess = usersWithoutAccess;
    this.isLocked = isLocked;
    this.showPanel = showPanel;
    this.fieldId = fieldId;
    this.analyticsClient = analyticsClient;
    this.contentId = contentId;
  }
}
